import ArchivosAdjuntosDropzone from "common/components/ArchivosAdjuntosDropzone"
import ArchivosAdjuntosFileItem from "common/components/ArchivosAdjuntosFileItem"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import { setArchivosAdjuntos } from "features/Crear/redux/slices/newDocumentoSettingsSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { nanoid } from "nanoid"
import { useCallback } from "react"
import { useTranslation } from "react-i18next"

const DocumentoSettingsArchivosAdjuntos = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { archivosAdjuntos } = useSelector(newDocumentoSettingsSelector)

  const handleUpload = useCallback(
    (newFiles: $TSMigrationFixMe) => {
      // @ts-expect-error TS(2345): Argument of type...
      dispatch(setArchivosAdjuntos([...archivosAdjuntos, ...newFiles]))
    },
    [archivosAdjuntos, dispatch]
  )

  const handleDelete = (fileIndex: $TSMigrationFixMe) => {
    dispatch(
      // @ts-expect-error TS(2345): Argument of type...
      setArchivosAdjuntos([
        ...archivosAdjuntos.slice(0, fileIndex),
        ...archivosAdjuntos.slice(fileIndex + 1),
      ])
    )
  }

  return (
    <div className='p-0 mt-5 text-left col'>
      <h5 className='h5 font-weight-500'>
        {t("crear.facturaRec.settings.attachmentsLabel")}
      </h5>

      <div className='mt-3'>
        <ArchivosAdjuntosDropzone handleUpload={handleUpload} />
      </div>

      <div className='mt-1'>
        {archivosAdjuntos?.map(
          (
            { name, nombre, size }: $TSMigrationFixMe,
            index: $TSMigrationFixMe
          ) => (
            <ArchivosAdjuntosFileItem
              key={nanoid()}
              name={name || nombre}
              size={size}
              onDelete={() => handleDelete(index)}
            />
          )
        )}
      </div>
    </div>
  )
}
export default DocumentoSettingsArchivosAdjuntos
